import React, { useEffect } from "react";
import { Alert } from "react-bootstrap";

const DEFAULT_TIMEOUT = 3000
export function TimedAlert({
  state = {
    queue: []
  },
  nextMessage
}) {
  const { queue } = state

  useEffect(() => {
    if (queue.length) {

      console.log('use effect alert')
      const timeoutId = setTimeout(() => {
        console.log('use effect timeout')
        nextMessage()
      }, queue[0].timeout || DEFAULT_TIMEOUT)

      return () => clearTimeout(timeoutId)
    }
  }, [queue, nextMessage])

  

  return (
    <div>
      <Alert dismissible
        style={{ position: 'fixed', zIndex: 99999, width: '40%', bottom: 0, left: '30%' }}
        show={!!queue.length}
        variant={queue[0] && queue[0].variant}
        onClose={x => { nextMessage() }}>
        {queue[0] && queue[0].message}
      </Alert>
    </div>
  )
}